import React, { useContext, useEffect, useState } from 'react';

import { ServiceResponse } from '../../../app/services/shared/interfaces';
import LazyLoading from '../../../components/LazyLoading';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { toast } from 'react-toastify';
import { VehicleModelDataForm } from '../../../app/models/VehicleModel';
import { VehicleType } from '../../../app/models/VehicleType';
import useVehicleModelService from '../../../app/services/hooks/useVehicleModelService';
import VehicleModelFormContainer from './VehicleModelFormContainer';

interface Props {
    vehicleModelId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const VehicleModelEdit = ({ vehicleModelId, onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const {
        fetchingEditVehicleModel,
        editVehicleModel,
        fetchingUpdateVehicleModel,
        updateVehicleModel
    } = useVehicleModelService();

    const [vehicleModel, setVehicleModel] = useState<VehicleModelDataForm>({
        name: '',
        vehicle_type: ''
    });
    const [vehicleTypes, setVehicleTypes] = useState<VehicleType[]>([]);
    const [errorFields, setErrorFields] = useState<any>();

    useEffect(() => {
        edit();
    }, []);

    const edit = () => {
        if (showLoading) showLoading('loading', 'Cargando modelo...');
        editVehicleModel(vehicleModelId, {
            onSuccess: (response: ServiceResponse) => {
                setVehicleModel(response.data.vehicle_model);
                setVehicleTypes(response.data.vehicle_types);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    };

    const update = () => {
        if (showLoading) showLoading('loading', 'Actualizando modelo...');
        updateVehicleModel(vehicleModelId, vehicleModel, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return fetchingEditVehicleModel ? (
        <LazyLoading height="300" />
    ) : (
        <VehicleModelFormContainer
            fetching={fetchingUpdateVehicleModel}
            action={update}
            cancel={cancel}
            vehicleModel={vehicleModel}
            setVehicleModel={setVehicleModel}
            vehicleTypes={vehicleTypes}
            errorFields={errorFields}
        />
    );
};

export default VehicleModelEdit;
